import { useState, useEffect, useCallback } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import logo from '../logo.jpg';
import main from '../Home-icon.svg.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import './navbarComp.css';
import Config from '../config/config';
import { SocialButtons } from './socialButtons';

const sections = ['home', 'o-nas', 'galeria', 'kontakt', 'attractions'];

export default function NavbarComp() {
    const [active, setActive] = useState('home');

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setActive(entry.target.id);
                    }
                });
            },
            { rootMargin: '-40% 0px -55% 0px' }
        );

        sections.forEach(id => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    const scrollTo = useCallback((id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, []);

    return (
        <>
            <header className="App-header">
                <img src={logo} alt="logo" />
            </header>
            <div className="sticky-wrapper">
                <Navbar expand="sm" className="navbar-sticky">
                    <Container>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <div className="d-flex flex-column flex-sm-row w-100 justify-content-center align-items-center gap-1">
                                <Nav>
                                    <Nav.Link className={active === 'home' ? 'active' : ''} onClick={() => scrollTo('home')}><img src={main} alt="main" /></Nav.Link>
                                    <Nav.Link className={active === 'o-nas' ? 'active' : ''} onClick={() => scrollTo('o-nas')}>O nas</Nav.Link>
                                    <Nav.Link className={active === 'galeria' ? 'active' : ''} onClick={() => scrollTo('galeria')}>Galeria</Nav.Link>
                                    <Nav.Link className={active === 'kontakt' ? 'active' : ''} onClick={() => scrollTo('kontakt')}>Kontakt</Nav.Link>
                                    <Nav.Link className={active === 'attractions' ? 'active' : ''} onClick={() => scrollTo('attractions')}>Atrakcje</Nav.Link>
                                </Nav>
                                <div>
                                    <SocialButtons socials={Config.SOCIALS} />
                                </div>
                            </div>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
        </>
    );
}
